export const DELIVERY_SELECTOR_TYPES = {
  courier: 'courier',
  pickup: 'pickup',
};

export const WIDGET_PLACES = {
  checkout: 'checkout',
  courier: 'courier',
  pickup: 'pickup',
  storeCard: 'storeCard',
};

export const WIDGET_TYPES = {
  stub: 'stub',
  onlyOneStore: 'onlyOneStore',
  oneStore: 'oneStore',
  oneOrder: 'oneOrder',
  courier: 'courier',
};
